import { useEffect, useState } from 'react';
import { useNavigate, useLocation ,Link} from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import { getOrders, getOrderInstance, deleteOrderInstance, updateOrder } from '../api/commerce';
import { fetchBidderBids, placeBid, deleteBid } from '../api/commerce';
import { useParams } from "react-router-dom";
import { ImageOff, Info } from "lucide-react";
import { SidebarProvider } from "../components/SidebarContext";
import Loading from '../components/loading/Loading';
import InfoMark from '../components/InfoMark';
import CountdownTimerMini from '../components/CountdownMini';
import ProductCardModal from '../components/ProductCardModal';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';
import SidebarToggle from '../components/SidebarToggle';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import "../css/BidMgmt.css";

const OrderReview = () => {
  const { user, isAuthenticated, loading} = useAuth();
  const [products, setProducts] = useState([]);
  const [productBids, setProductBids] = useState([]);
  const [bidAmount, setBidAmount] = useState("");
  const [infoCredit, setCredit] = useState();
  const [InfoP, setInfoP] = useState(null);
  const [isInfoModal, setInfoModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const [error, setError] = useState(null);
  const [consoleError, setConsoleError] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = user;

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      }
    }
  }, [user, isAuthenticated, loading, navigate, location, lang]);
  
  useEffect(() => {
    fetch("/data/InfoNote.json")
      .then((res) => res.json())
      .then((data) => setInfoP(data.BidManagement))
      .catch((err) => setConsoleError("Error loading content:", err));
  }, []);

  const fetchBids = async () => {
    try {
      const res = await fetchBidderBids();
      setProductBids(res);
    } catch (error) {
      setConsoleError("Error loading user bids:", error);
    } 
  };

  useEffect(() => {
    fetchBids();
  }, []);
  

  // Update bids
  const handleBidDelete = async (bidId) => {
    if (!window.confirm(setlang==="en"?"Are you sure about removing your bid?":"آیا می خوای پیشنهاد قیمتت رو حذف کنی")) return;
    try {
      await deleteBid(bidId); 
      const updatedBids = await fetchBidderBids();
      setProductBids(updatedBids);
    } catch (error) {
      setConsoleError("Error deleting bid:", error);
      alert(setlang==="en"?"Failed to delete your bid, please try again.":"مشکلی در حذف پیشنهاد رخ داد، لطفا دوباره وارد حساب کاربری شو");
    }
  };

  // Utilities
  const openModal = (order) => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target !== e.currentTarget) {
      closeModal();
    }
  };

  dayjs.extend(utc);
  dayjs.extend(jalaliday);
  const toPersiDigits = (str) => 
    str
    .replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
    .replace(/\./g, '/');


  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])


  if (loading) return <Loading />;  
  if (!isAuthenticated) return <p>{setlang==="en"?"You must be logged in to review bids.":"لطفا ابتدا وارد حساب کاربری شو"}</p>;
  if (!productBids) return (
    <>
      <NavbarLog />
      <SidebarProvider>
      <Info size={25} className={setlang==="en"?"InfoMark-en":"InfoMark-fa"} onMouseEnter={()=>setInfoModal(true)} onMouseLeave={()=>setInfoModal(false)}/>
      {isInfoModal && <InfoMark info={setlang==="en"?InfoP.en:InfoP.fa} setlang={setlang}/>}

        <div className="order-page">
        {setlang==="en" && 
          <Sidebar />
        }
        <SidebarToggle />

        <div className='order-list'>
          <div style={{margin:"50px", alignContent:"center"}}>
            <p>{setlang==="en"?"No bids in place yet":"پیشنهادی در حال حاظر وجود ندارد"}</p>
          </div>
        </div>
        </div>
        {setlang==="fa" && 
          <Sidebar />
        }
      </SidebarProvider>
      <Footer />
    </>
    )
  
  //product information 
  return (
    <>
      <NavbarLog />
      <SidebarProvider>

      <Info size={25} className={setlang==="en"?"InfoMark-en":"InfoMark-fa"} onMouseEnter={()=>setInfoModal(true)} onMouseLeave={()=>setInfoModal(false)}/>
      {isInfoModal && <InfoMark info={setlang==="en"?InfoP.en:InfoP.fa} setlang={setlang}/>}

      <div className={setlang==="en"?"bid-page-en":"bid-page-fa"}>
      <SidebarToggle />

      {setlang==="en" && 
          <Sidebar />
        }
          
        <div className='bid-list'>
          {productBids.length === 0 ? (
            <p>{setlang==="en"?"No bids in place yet":"شما در حال حاضر در مزایده‌ای شرکت ندارید"}</p>
          ) : (
            productBids.map((bid) => (
              <div key={bid.id} className='bidItem-list'>
                <h2>Open Bids</h2>
                <ul>
                    <li key={bid.id}>
                      <div className="bid-images">
                        {/* Images */}
                        {Array.isArray(bid.images) && bid.images.length > 0 &&
                          bid.images.map((img) => (
                            <img
                              key={img.id}
                              src={img.image}
                              alt={img.id}
                              className="bid-image"
                            />
                          ))
                        }
                        {/* Videos */}
                        {Array.isArray(bid.videos) && bid.videos.length > 0 &&
                          bid.videos.map((vid) => (
                            <video
                              key={vid.id} 
                              src={vid.video}
                              controls
                              className="bid-image"
                            />
                          ))
                        }
                        {/* Logos */}
                        {bid.images.length < 1 && bid.videos.length < 1 &&
                          <ImageOff size={90} className="bid-logo" />
                        }
                      </div>  
                    
                      <div className="bid-card">
                        <div className={setlang === "en" ? "bid-section-info" : "bid-section-info-fa" }>
                        {bid.description && <p><strong>{setlang === "en" ? "Description: " : "توضیحات: " }</strong> {bid.description}</p>}
                        {bid.artist && <p><strong>{setlang === "en" ? "By: " : "اثر: " }</strong> {bid.artist}</p>}
                        {bid.category && <p><strong>{setlang === "en" ? "Category: " : "دسته‌بندی: " }</strong> {bid.category}</p>}
                        {bid.style && <p><strong>{setlang === "en" ? "Style: " : "استایل: " }</strong> {bid.style}</p>}
                        {bid.material && <p><strong>{setlang === "en" ? "Material: " : "جنس ساخت: " }</strong> {bid.material}</p>}
                        {bid.delivered_by && <p><strong>{setlang === "en" ? "Delivery Mode: " : "روش ارسال محصول: " }</strong> {bid.delivered_by}</p>}
                        {bid.pickup_address && <p><strong>{setlang === "en" ? "Delivery Details: " : "روش دریافت محصول: " }</strong> {bid.pickup_address}</p>}
                        {bid.price && (
                          setlang==="en"?
                          <div style={{marginBottom:"15px", marginTop:"15px"}}><span><strong>Price: </strong></span> <span style={{color:"#38728e", fontWeight:"550"}}>IRT {new Number(bid.price).toLocaleString()}</span></div>
                          :
                          <div style={{marginBottom:"15px", marginTop:"15px"}}><span><strong>قیمت (تومان): </strong></span><span style={{color:"#38728e", fontWeight:"550"}}>{toPersiDigits(new Number(bid.price).toLocaleString())}</span></div>
                        )}

                        </div>
                        <CountdownTimerMini targetTime={bid.bidding_deadline} targetTime_pa={dayjs.utc(bid.bidding_deadline).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm")} setlang={setlang}/>
                        <div className="bidder-table">
                          <thead>
                            <tr>
                              <th>{setlang === "en" ? "Bidder" : "کاربر" }</th>
                              <th>{setlang === "en" ? "Amount" : "پیشنهاد" }</th>
                              <th>{setlang === "en" ? "Date" : "تاریخ" }</th>
                              <th >{setlang === "en" ? "Status" : "وضعیت" }</th>
                              <th style={{display:"flex", placeSelf:"center"}}>{setlang === "en" ? "Cancel" : "لغو" }</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bid.bids.map((b, index) => (
                              <tr key={b.id}>
                                <td>{b.bidder_name}</td>
                                {setlang==="en"? 
                                <>
                                  <td>IRT {new Number(b.bid_amount).toLocaleString()}</td>
                                  <td>{dayjs.utc(b.created_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm")}</td>
                                </>
                                :
                                <>
                                  <td style={{direction:"rtl"}}> {toPersiDigits(new Number(b.bid_amount).toLocaleString())} تومان</td>
                                  <td>{toPersiDigits(dayjs.utc(b.created_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm"))}</td>
                                </>                                
                                }
                                <td>
                                  {index === 0 ? (
                                    <span className="highest-bid">{setlang === "en" ?  "Highest" : "بالا" }</span>
                                  ) : (
                                    <span className="outbid">{setlang === "en" ?  "Outbid" : "پایین" }</span>
                                  )}
                                </td>
                                {currentUser?.id === b.bidder && ( 
                                  <td>
                                    <button onClick={() => handleBidDelete(b.id)}>
                                      {setlang === "en" ? "cancel" : "لغو" }
                                    </button>
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </div>
                      </div> 
                    </li>
                </ul>

                <div className="bid-actions">
                  <Link to={`/${setlang}/productitenary/${bid.id}/${bid.name}/${bid.artist}/${bid.description}/${bid.category}/`}> 
                    <button className='btn'>{setlang==="en"?"View Article":"صفحه آگهی"}</button>
                  </Link>
                  <button className='btn' onClick={()=>setIsModalOpen(bid.id)}>{setlang==="en"?"View & Update Bid":"پیشنهاد جدید"}</button>
                

                {isModalOpen === bid.id && 
                <div onClick={handleOverlayClick} key={bid.id}>
                  <ProductCardModal 
                  isModalOpen={isModalOpen}
                  productId={bid.id}
                  ownerId={bid.owner_id}
                  ownerUsername={bid.name}
                  images={bid.images}
                  videos={bid.videos}
                  name={bid.name}
                  description={bid.description}
                  artist={bid.artist}
                  style={bid.style}
                  category={bid.category}
                  material={bid.material}
                  feature_one={bid.feature_one}
                  feature_two={bid.feature_two}
                  length={bid.length}
                  width={bid.width}
                  height={bid.height}
                  weight={bid.weight}
                  date={bid.created_at}
                  date_pa={dayjs.utc(bid.created_at).calendar("jalali").locale("fa").format("YYYY/MM/DD")}
                  price={bid.price}
                  bidzone_stored={bid.bidzone_stored}
                  isAuthenticated={isAuthenticated}
                  is_biddable={bid.is_biddable}
                  b_deadline={bid.bidding_deadline}
                  b_deadline_pa={dayjs.utc(bid.bidding_deadline).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm")}
                  user={user}
                  delivered_by={bid.delivered_by}
                  pickup_address={bid.pickup_address}
                  setlang={setlang}
                  currentUser={currentUser}
                  />
                </div>
                }
                </div>

              </div>
            ))
          )}
          </div> 
          {setlang==="fa" && 
          <Sidebar />
        }
        </div>
        </SidebarProvider>
      <Footer />
    </>
  );
};

export default OrderReview;
